/**
 * Wave 2 — Spec §6.3 public receipt page. The page itself lives in
 * `PublicReceiptPage` so it can be rendered without the router.
 */
import { createFileRoute } from '@tanstack/react-router';
import { PublicReceiptPage } from '@/components/public/PublicReceiptPage';

export const Route = createFileRoute('/(public)/receipt/$id')({
  component: ReceiptRoute,
});

function ReceiptRoute() {
  const { id } = Route.useParams();
  return <PublicReceiptPage id={id} />;
}
